import React from "react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Icon,
} from "~/components/ui";

export const TableMenuAction = ({
  children,
  mobile,
  variant,
}: {
  children: React.ReactNode;
  mobile?: boolean;
  variant?: "default" | "ghost" | "outline";
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant={variant || "ghost"}
          size="default"
          className="flex h-9 items-center gap-2"
        >
          <Icon
            name={mobile ? "Ellipsis" : "EllipsisVertical"}
            className="h-5 w-5 text-neutral-500"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="bottom" className="rounded-2xl">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
